import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Select,
  Row,
  Col,
  message,
  Space,
  Radio,
} from "antd";
import React, { useEffect, useState } from "react";
import { collection, doc, getDocs, query, updateDoc, where } from "firebase/firestore";
import dayjs from "dayjs";
import { auth, db } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

const LateFeePolicy = ({ data, dataId }) => {
  const [user, loading] = useAuthState(auth);
  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [amount, setAmount] = useState(data?.lateFeeType);
  const [IsDisableField, setIsDisableField] = useState(data?.gracePeriod);

  const [companyName, setCompanyName] = useState("");

   const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const { Option } = Select;
  const numberOptions = Array.from({ length: 28 }, (_, index) => ({
    label: String(index + 1),
    value: String(index + 1),
  }));
  const initialValues = {
    baseLateFeeFlat: data?.baseLateFeeFlat || "",
    baseLateFeePercent: data?.baseLateFeePercent || "",
    lateFeeType: data?.lateFeeType || "",
    gracePeriod: data?.gracePeriod || "",
    eligibleCharges: data?.eligibleCharges || "",
    gracePeriodAfterDays: data?.gracePeriodAfterDays || "",
    gracePeriodAfterDays: data?.gracePeriodAfterDays || "",
    gracePeriodOnDay: data?.gracePeriodOnDay || "",
    eligibleCharges: data?.eligibleCharges || "",
    effectiveOn: data?.effectiveOn ? dayjs(data?.effectiveOn, "YYYY-MM-DD") : "",
  };

  const onFinish = (values) => {
    console.log("Success:", values);

    try {

      const propertyRef = doc(db, "companies", companyName, "properties", dataId);

      const lateFeePolicy = {
        "LateFeePolicy.baseLateFeeFlat": values.baseLateFeeFlat || "",
        "LateFeePolicy.baseLateFeePercent": values.baseLateFeePercent || "",
        "LateFeePolicy.lateFeeType": amount || "",
        "LateFeePolicy.gracePeriod": IsDisableField || "",
        "LateFeePolicy.gracePeriodAfterDays": values.gracePeriodAfterDays || "",
        "LateFeePolicy.gracePeriodOnDay": values.gracePeriodOnDay || "",
        "LateFeePolicy.eligibleCharges": values.eligibleCharges || "",
        "LateFeePolicy.effectiveOn": values.effectiveOn ? values.effectiveOn.format("YYYY-MM-DD") : "",
      }
      updateDoc(propertyRef, lateFeePolicy);
      setIsEditActive(false);
      message.success("Property Information Data Updated Successfully", 3);
    } catch (error) {
      console.log("Error updating Properties data:", error);
      message.error("Failed to update Properties Information data.", 3);

      setIsWaiting(false);
    }
  };
  const handleDollarOrPerc = (e) => {
    setAmount(e.target.value);
  };
  const disableField = (e) => {
    setIsDisableField(e.target.value);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div>
      <Card
        title="Late Fee Policy"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
                setIsWaiting(false);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <>
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            initialValues={initialValues}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            colon={false}
          >
            <h4>Current Late Fee Policy</h4>
            {isEditActive ? (
              <Form.Item
                label="Late Fee Type"
                name="lateFeeType"
                rules={[{ required: true }]}
              >
                <Radio.Group onChange={handleDollarOrPerc}>
                  <Space direction="vertical">
                    <Radio value="Flat">Flat</Radio>
                    <Radio value="Percent">Percentage</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            ) : (
              <></>
            )}
            <Form.Item
              label="Base Late Fee"
              name={amount === "Flat" ? "baseLateFeeFlat" : "baseLateFeePercent"}
              rules={[{ required: true }]}
            >
              {isEditActive ? (
                <Input type="Number" prefix={amount === "Flat" ? "$" : "%"} />
              ) : (
                <p>
                  {data?.baseLateFeeFlat ? data?.baseLateFeeFlat : ""}
                </p>
              )}
            </Form.Item>

            <Form.Item
              label="Eligible Charges"
              rules={[{ required: true }]}
              name="eligibleCharges"
            >
              {isEditActive ? (
                <Select showSearch style={{ width: "100%" }}>
                  <Option value="All Recurring Charges">All Recurring Charges</Option>
                  <Option value="Every Charge">Every Charge</Option>
                  <Option value="Only Recurring Rent">Only Recurring rent</Option>
                </Select>
              ) : (
                <p>
                  {data?.eligibleCharges === "" ? "--" : data?.eligibleCharges}
                </p>
              )}
            </Form.Item>
            {isEditActive ? (
              <Form.Item
                label="Effective On"
                name="effectiveOn"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            ) : (
              <Form.Item label="Calculate Fee From">
                <p>
                  {data?.calculateFeeFrom === ""
                    ? "--"
                    : data?.calculateFeeFrom}
                </p>
              </Form.Item>
            )}
            {isEditActive ? (
              <Row gutter={8}>
                <Col span={10}>
                  <Form.Item
                    label="Grace Period"
                    name="gracePeriod"
                    rules={[{ required: true }]}
                  >
                    <Radio.Group onChange={disableField}>
                      <Space direction="vertical">
                        <Radio value="after">After</Radio>
                        <Radio value="On day">On Day</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {IsDisableField === "after" ? (
                    <Form.Item
                      name="gracePeriodAfterDays"
                      rules={[{ required: true }]}
                    >
                      <Input type="Number" />
                    </Form.Item>
                  ) : (
                    <Form.Item
                      name="gracePeriodOnDay"
                      rules={[{ required: true }]}
                    >
                      <Select options={numberOptions} />
                    </Form.Item>
                  )}
                </Col>
              </Row>
            ) : (
              <>
                <Form.Item label="Ignore Partial Payments">
                  <p>
                    {data?.partialPayments === ""
                      ? "--"
                      : data?.partialPayments}
                  </p>
                </Form.Item>
                <Form.Item label="Daily Amount / Monthly Max">
                  <p>
                    {data?.maxDailyLateFee === ""
                      ? "--"
                      : data?.maxDailyLateFee}
                  </p>
                </Form.Item>
                <Form.Item label="Grace Period">
                  <p>{data?.gracePeriod === "" ? "--" : data?.gracePeriod}</p>
                </Form.Item>
                <Form.Item label="Grace Balance">
                  <p>{data?.graceBalance}</p>
                </Form.Item>
              </>
            )}
            {isEditActive && (
              <Row gutter={16}>
                <Col>
                  <Button type="primary" htmlType="submit" disabled={isWaiting}>
                    {isWaiting ? "Please wait..." : "Save"}
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={() => {
                      setIsEditActive(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            )}
          </Form>
        </>
      </Card>
    </div>
  );
};

export default LateFeePolicy;
